import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';

import { routes } from '@/router';

type RoutesKeys = keyof typeof routes;

const routesList: RouteRecordRaw[] = [];
for (const route in routes) {
  const routeRecord = routes[route as RoutesKeys] as RouteRecordRaw;
  routesList.push(routeRecord);
}

const router = createRouter({
  history: createWebHistory(),
  routes: routesList as RouteRecordRaw[],
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      };
    }
    return { top: 0 };
  }
});

export default router;
